module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh-CN":{"manager_review_desc":"此评论是 %{brandName} 管理员注册的评论。"}}')
  delete Component.options._Ctor
}
